import React from "react";
import styles from "./Style.module.css";
import useRoleCreateHook from "./RoleCreate.hook";
import RoleTableComponent from "./component/RoleTable.componnet";
import CustomTextField from "../../components/FormFields/TextField/TextField.component";
import { CreateActionComponent, CreateHeadaerComponent, HeaderTitleComponet } from "../../components/CustomListHeader/CustomListHeader";
import ShadowBox from "../../components/ShadowBox/ShadowBox";
import { makeStyles, useTheme } from "@mui/styles";
import CustomSelectField from "../../components/FormFields/SelectField/SelectField.component";
import capitalizeFirstLetter from "../../hooks/CommonFunction";

const useStyles = makeStyles((theme) => ({
  iconBtnError: {
    color: theme.palette.error.dark,
  },
  deleteBtn: {
    color: "red",
  },
}));

const RoleCreate = () => {
  const {
    form,
    errorData,
    handleSubmit,
    onBlurHandler,
    changeTextData,
    isSubmitting,
    cancelRole,
    permisionChangeHandler,
    id,
    setPermissions,
    permission,
    listData,
  } = useRoleCreateHook();
  const classes = useStyles();
  const theme = useTheme();
  return (
    <>
      <CreateHeadaerComponent title={id ? "Edit Role" : "Create Role"} />
      <div className={styles.container}>
        <ShadowBox width={"100%"}>
          <HeaderTitleComponet headerTitle={" Role Details"} />
          <div className={"formFlex"}>
            <div className={"formGroup"}>
              <CustomTextField
                isError={errorData?.name}
                errorText={errorData?.name}
                label={
                  <>
                    Role Name
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={form?.name}
                onTextChange={(text) => {
                  changeTextData(text, "name");
                }}
                onBlur={() => {
                  onBlurHandler("name");
                }}
              />
            </div>
            {/* <div className={"formGroup"}>
              <CustomSelectField
                isError={errorData?.applies_to}
                errorText={errorData?.applies_to}
                label={
                  <>
                     Applies To
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>
                }
                value={form?.applies_to}
                onTextChange={(text) => {
                  changeTextData(text, "applies_to");
                }}
                onBlur={() => {
                  onBlurHandler("applies_to");
                }}
              >
                {listData?.applies_to?.map((item) => {
                    return (
                      <MenuItem
                        key={item?.id}
                        value={item?.id}
                      >{`${capitalizeFirstLetter(item?.name)}`}</MenuItem>
                    );
                  })}
              </CustomSelectField>
            </div> */}
          </div>
          <div className={"formFlex"}>
            <div className={"formGroup"}>
              <CustomTextField
                isError={errorData?.description}
                errorText={errorData?.description}
                multiline
                rows="3"
                label="Description"
                value={form?.description}
                onTextChange={(text) => {
                  changeTextData(text, "description");
                }}
                onBlur={() => {
                  onBlurHandler("description");
                }}
              />
            </div>
          </div>
        </ShadowBox>
        <div>
          <RoleTableComponent
            classes={classes}
            // data={data}
            permissions={permission}
            changeTextData={changeTextData}
            permisionChangeHandler={permisionChangeHandler}
            setPermissions={setPermissions}
          />
        </div>
        <CreateActionComponent
          handleSubmit={handleSubmit}
          isRemove={false}
          isSubmitting={isSubmitting}
          removeHandler={cancelRole}
          title={id ? "UPDATE" : "CREATE"}
        />
      </div>

    </>
  );
};

export default RoleCreate;
